import { nl2br } from '../../utils/utils';
import { Component, Host, Element, h, Prop, State } from '@stencil/core';

const EnvelopeIconOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
    />
  </svg>
);

const LinkIconOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="w-6 h-6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
    />
  </svg>
);

const PhoneIconOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
    />
  </svg>
);

const TYPE_EMAIL = 'email';
const TYPE_URL = 'url';
const TYPE_PHONE = 'phone';

@Component({
  tag: 'webcomet-contact-block',
  styleUrl: 'contact-block.scss',
  shadow: true,
})
export class Contact {
  @Element() el: HTMLWebcometContactBlockElement;

  @State() contactMethods = [];

  /**
   * The primary color to use in the component
   */
  @Prop() primaryColor = '#d24919';

  /**
   * The contact URL
   */
  @Prop() primaryContactMethod = null;

  /**
   * The contact URL
   */
  @Prop() url = null;

  /**
   * The contact URL link text
   */
  @Prop() urlText = null;

  /**
   * The contact email address
   */
  @Prop() email = null;

  /**
   * The contact phone number
   */
  @Prop() phone = null;

  /**
   * The contact description
   */
  @Prop() description = null;

  componentWillLoad(): void {
    const style = document.createElement('style');
    style.innerHTML = `
      a, a:hover, a:visited, a:focus { color: ${this.primaryColor}; }
    `;
    this.el.shadowRoot.insertBefore(
      style,
      this.el.shadowRoot.querySelector('.widget')
    );
  }

  private renderContactMethod(type: string) {
    switch (type) {
      case TYPE_EMAIL:
        return <a href={`mailto:${this.email}`}>{this.email}</a>;

      case TYPE_URL:
        return (
          <a href={`${this.url}`} target="_blank">
            {this.urlText ? this.urlText : this.url}
          </a>
        );

      case TYPE_PHONE:
        return this.phone;

      default:
        return this[this.primaryContactMethod];
    }
  }

  private renderIcon() {
    switch (this.primaryContactMethod) {
      case TYPE_EMAIL:
        return <EnvelopeIconOutline></EnvelopeIconOutline>;

      case TYPE_PHONE:
        return <PhoneIconOutline></PhoneIconOutline>;

      case TYPE_URL:
        return <LinkIconOutline></LinkIconOutline>;

      default:
        return null;
    }
  }

  private getLinks() {
    const available = [TYPE_URL, TYPE_PHONE, TYPE_EMAIL];

    return available.filter((type) => {
      return type !== this.primaryContactMethod && this[type] !== null;
    });
  }

  render() {
    return (
      <Host>
        <div class="wrapper">
          {this.primaryContactMethod ? (
            <div class="icon__wrapper">{this.renderIcon()}</div>
          ) : (
            ''
          )}
          <div class="content__wrapper">
            <div class="primary">
              {this.renderContactMethod(this.primaryContactMethod)}
            </div>
            {this.description ? (
              <div
                class="description"
                style={{
                  marginTop: this[this.primaryContactMethod] ? '.5rem' : null,
                }}
                innerHTML={nl2br(this.description)}
              ></div>
            ) : (
              ''
            )}
            {this.getLinks().length > 0 ? (
              <div
                class="links"
                style={{
                  marginTop:
                    this[this.primaryContactMethod] || this.description
                      ? '.5rem'
                      : null,
                }}
              >
                {this.getLinks().map((type) => (
                  <div class="link">{this.renderContactMethod(type)}</div>
                ))}
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </Host>
    );
  }
}
